function WhatsAppFAB() {
  return (
    <a
      href="https://wa.me/256702499649?text=Hello%20Salama%20Consult%2C%20I%20would%20like%20to%20discuss%20a%20project."
      className="whatsapp-fab"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <i className="fab fa-whatsapp" />
    </a>
  );
}

export default WhatsAppFAB;
